// Every Coolmate service-to-service HTTP call must identify itself with a User-Agent.
// A UA-less internal request is indistinguishable from the scraper traffic the zone
// firewall blocks: on 2026-08-22 a zone-wide "block empty User-Agent" rule silently
// killed the API -> media-vault render dispatch (social autopilot scheduled 0 posts)
// and the hourly sitemap prewarm, because neither sent one.
export const INTERNAL_USER_AGENTS = {
  webSsr: 'coolmate-web-ssr',
  apiVault: 'coolmate-api-vault',
  authIdentity: 'coolmate-auth-identity',
  sdk: 'coolmate-sdk',
} as const;
